export const TEST_FUNCTION = 'TEST_FUNCTION';
export const GITHUB_PROJECTS = 'GITHUB_PROJECTS';
